import {Component, Injectable, TemplateRef, Type} from "@angular/core";

export interface ToastInfo {
    Header: string;
    ClassName?: string
    Content: string | Type<Component>;
    Context?: any,
    Delay?: number,
}

@Injectable()
export class ToastService {
    public Toasts: ToastInfo[] = [];

    public Show(toast: ToastInfo) {
        this.Toasts.push(toast);
    }
    
    public RemoveToast(index: number) {
        this.Toasts.splice(index, 1);
    }
}